var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"box-card bread"},[_c('div',[_c('img',{staticClass:"bread_pin",attrs:{"src":_vm.point,"alt":"南软科技"}}),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-d-arrow-right"}},_vm._l((_vm.getBread),function(item,index){return _c('el-breadcrumb-item',{key:index},[_vm._v(_vm._s(item.meta.title))])}))],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dcce87d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BreadcrumbWly.vue
// module id = null
// module chunks = 